import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Refetches resource lists and single resources after a desk changed
 * (availability, dedication, team access).
 */
export const useInvalidateResources = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["organizations.resourcesAll"]
    });
    await queryClient.invalidateQueries({ queryKey: ["resource"] });
  }, [queryClient]);
};
